import { FormikHelpers } from "formik";
import { toast } from "react-toastify";
import { api } from "../../../Api/Api";
import { AddTransferInitialValues } from "../../../Pages/Private/MemberModule/TransferRequest/AddTransferRequest/AddTransferRequestMethods/FormikValidation";

export const addModalInitialValuesHandler = (
  modalEditData: any,
  setAddModalInitialValues: Function,
  setEditMode: Function
) => {
  if (modalEditData?.length !== 0) {
    setEditMode(true);
    setAddModalInitialValues({
      ...AddTransferInitialValues,
      ...modalEditData,
    });
  } else {
    setEditMode(false);
    setAddModalInitialValues(AddTransferInitialValues);
  }
};

export const directOfficeChangeSubmitHandler = async (
  values: any,
  actions: FormikHelpers<any>,
  setModal: Function,
  Refetch: Function,
  memberData: any
) => {
  const transferPayload = {
    user: memberData?.id || memberData?.user_id,
    office: values?.to_office,
    district: values?.district,
    block: values?.block,
    designation_id: values?.designation || null,
    cadre_id: values?.cadre || null,
    type: values?.type,
    GO_order: values?.GO_order || "",
    GO_order_date: values?.GO_order_date || null,
    reason: values?.reason || "",
  };

  // Use .then().catch() pattern like other handlers in the codebase
  api
    .post("/transfer/direct-transfer", transferPayload, true)
    .then(async function ([success, response]: any) {
      if (success) {
        toast.success("Office changed successfully and logged", {
          toastId: "office_change_success",
        });
        
        // Reset form and stop loading
        actions.resetForm();
        actions.setSubmitting(false);
        
        // Close modal
        setModal(false);
        
        // Refetch after modal closes
        if (Refetch && typeof Refetch === 'function') {
          Refetch();
        }
      } else {
        actions.setSubmitting(false);
        toast.error(response?.message || "Error changing office", {
          toastId: "office_change_error",
        });
      }
    })
    .catch((err: any) => {
      actions.setSubmitting(false);
      console.error("Error changing office:", err);
      
      toast.error(
        err?.response?.data?.message || 
        err?.message || 
        "Error changing office",
        { toastId: "office_change_error" }
      );
    });
};